export const FieldDiscreteValues: any[] = [
    { name: 'zakres_ubezpieczenia_grad', caption: 'Tak', value: 'true', sortOrder: 0 },
    { name: 'zakres_ubezpieczenia_przymrozki', caption: 'Tak', value: 'true', sortOrder: 1 },
    { name: 'zakres_ubezpieczenia_deszcz', caption: 'Tak', value: 'true', sortOrder: 2 },
    { name: 'zakres_ubezpieczenia_huragan', caption: 'Tak', value: 'true', sortOrder: 3 },
    { name: 'zakres_ubezpieczenia_ogien', caption: 'Tak', value: 'true', sortOrder: 4 },
    { name: 'zakres_ubezpieczenia_piorun', caption: 'Tak', value: 'true', sortOrder: 5 },
    { name: 'zakres_ubezpieczenia_obsuniecie_ziemi', caption: 'Tak', value: 'true', sortOrder: 6 },
    { name: 'zakres_ubezpieczenia_lawina', caption: 'Tak', value: 'true', sortOrder: 7 },
    { name: 'zakres_ubezpieczenia_powodz', caption: 'Tak', value: 'true', sortOrder: 8 },
    { name: 'zakres_ubezpieczenia_susza', caption: 'Tak', value: 'true', sortOrder: 9 },
    { name: 'zakres_ubezpieczenia_skutki_zlego_przezimowania', caption: 'Tak', value: 'true', sortOrder: 10 },
    { name: 'udzial_wlasny_0', caption: 'Tak', value: 'true', sortOrder: 0 },
    { name: 'udzial_wlasny_1', caption: 'Nie', value: 'false', sortOrder: 1 },
    { name: 'minimalna_wysokosc_szkody_0', caption: '10%', value: '10', sortOrder: 0 },
    { name: 'minimalna_wysokosc_szkody_1', caption: '8%', value: '8', sortOrder: 1 }
];